module.exports = __webpack_public_path__ + "static/media/vr-goggles.cdd2e063.jpg";